<style src="./Occupation.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="user">
    <content-header path="Cadastro / Ocupação"/>

    <form v-on:submit.prevent="searchSubmit">
      <section class="form-box row">
        <textbox
        v-model="searchText"
        label="Buscar ocupação"
        placeholder="Digite o nome de uma ocupação"
        class="col-9"/>
        <button class="btn-primary col-3" @click="addNew">
          <icon-add />
          <span class="hide-md">Inserir Novo</span>
        </button>
      </section>
    </form>

    <section class="form-box list">
      <ul class="grid-list-container">
        <li class="grid-list-header">
          <ul>
            <li class="col-10">Nome</li>
          </ul>
        </li>

        <li class="grid-list-empty" v-if="!list || list.length === 0">
          <icon-empty />
          <h3>Ainda não há registros</h3>
        </li>

        <li
          class="grid-list-item"
          v-for="itemList, indexList in filteredList">

          <ul class="grid-item-column-container">
            <li class="col-10">
              <span class="name">{{ itemList.name }}</span>
            </li>
            <li class="col-2">
              <button class="column-button" @click="edit(indexList)">
                <icon-edit />
              </button>
              <button-remove @remove="removeItem(indexList)"/>
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <div
      v-shortkey="['ctrl', 'alt', 'n']"
      @shortkey="addNew">
      <new-occupation
        v-if="showNewOccupationRightPanel"
        @cancel="cancelAddNew"
        @success="occupationAddedSuccessful" />
    </div>

    <div>
      <edit-occupation
        v-if="showEditRightPanel"
        :item="editData"
        @cancel="cancelEdit"
        @success="occupationEditSuccessful" />
    </div>

  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import {Textbox, ButtonRemove} from '@/components/primitives'
import {IconAdd, IconGarbage, IconEdit, IconEmpty} from '@/components/primitives/icons'
import { GetOccupationList, RemoveOccupationList } from '@/brain/record/occupation'
import NewOccupation from './right-panel/new-occupation/NewOccupation'
import EditOccupation from './right-panel/edit-occupation/EditOccupation'

export default {
  name: 'Occupation',
  components: {
    ContentHeader,
    Textbox,
    ButtonRemove,
    IconAdd,
    IconEdit,
    IconGarbage,
    IconEmpty,
    NewOccupation,
    EditOccupation
  },
  data () {
    return {
      searchText: '',
      showNewOccupationRightPanel: false,
      showEditRightPanel: false,
      editData: null,
      list: []
    }
  },
  computed: {
    filteredList () {
      const filteredList = this.list.filter((pValue) => {
        const caseValueInsensitive = pValue.name ? pValue.name.toLowerCase() : false
        const caseFilterInsensitive = this.searchText.toLowerCase()
        return caseValueInsensitive ? caseValueInsensitive.includes(caseFilterInsensitive) : false
      })
      return filteredList
    }
  },
  mounted () {
    this.loadAllOccupations()
  },
  methods: {
    searchSubmit () {},
    loadAllOccupations () {
      this.list = []
      GetOccupationList()
        .then((pData) => {
          this.list = pData
        })
    },
    addNew () {
      this.showNewOccupationRightPanel = true
    },
    cancelAddNew () {
      this.showNewOccupationRightPanel = false
    },
    removeItem (listIndex) {
      const _id = this.filteredList[listIndex]._id
      const idx = listIndex
      RemoveOccupationList({ _id, idx })
        .then((listIndexRemove) => {
          this.loadAllOccupations()
        })
    },
    occupationAddedSuccessful () {
      this.loadAllOccupations()
    },
    edit (listIndex) {
      this.editData = this.filteredList[listIndex]
      this.showEditRightPanel = true
    },
    cancelEdit () {
      this.showEditRightPanel = false
    },
    occupationEditSuccessful () {
      this.loadAllOccupations()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/occupation/Occupation.vue